// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";
import {getMainParentRouteName} from "@/lib/lib";
const pageClass = 'reports-page';

const defaultSetRoute = {
    reportTemplate: (route, router, template) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.reports.main) {
            if(consts.app.$isDevelopment) console.warn('reports', route);
            return false;
        }
        router.push({
            name: consts.routerNames.reports.template,
            params: {
                template
            },
            query: {...route.query}
        })
    },
    localeTemplate: (route, router, routeName) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.reports.main) {
            if(consts.app.$isDevelopment) console.warn('reports', route);
            return false;
        }
        router.push({
            name: routeName,
            params: {
            },
            query: {...route.query}
        })
    },
    reportSystem: (route, router, report) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.reports.main) {
            if(consts.app.$isDevelopment) console.warn('reports', route);
            return false;
        }
        router.push({
            name: consts.routerNames.reports.system,
            params: {
                template: report.id_report,
                timeFrom: report.time_from,
                timeTo: report.time_to,
                objectType: report.object_type,
                objectId: report.object_id,
            },
            query: {...route.query}
        })
    },
    reportMongo: (route, router, template, reportId, timeFrom, timeTo, objectType, objectId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.reports.main) {
            if(consts.app.$isDevelopment) console.warn('reports', route);
            return false;
        }
        router.push({
            name: consts.routerNames.reports.mongo,
            params: {
                reportId,
                timeFrom,
                timeTo,
                objectType,
                objectId,
            },
            query: {...route.query}
        })
    },
    returnToParent: (route, router) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.reports.main) {
            if (consts.app.$isDevelopment) console.warn(consts.routerNames.reports.main + ' returnToParent', route);
            return false;
        }
        let name = route.meta?.parentRouteName || consts.routerNames.routes.main;
        router.push({
            name: name,
            params: {
                ...route.params,
            },
            query: {}
        })
    },
    returnToMainParent: (route, router) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.reports.main) {
            if (consts.app.$isDevelopment) console.warn(consts.routerNames.reports.main + ' returnToParent', route);
            return false;
        }
        let name = route.meta?.mainRouteName || consts.routerNames.units.main;
        router.push({
            name: name,
            params: {
                ...route.params,
            },
            query: {}
        })
    },
    editJobManager: (route, router, reportSchedulerId, filter) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.reports.main) {
            if(consts.app.$isDevelopment) console.warn('editJobManager', route);
            return false
        }
        let query = filter ? {...route.query, ...filter} : route.query
        router.push({
            name: consts.routerNames.reports.jobManager.edit,
            params: {
                reportSchedulerId,
            },
            query: {...query}
        })
    },
}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.portal') ? [] : [
    {
        path: 'reports/:pathMatch(.*)?',
        name: consts.routerNames.reports.main,
        meta: {
            mainRouteName: consts.routerNames.reports.main,
            pageClass,
            layers: consts.defaultSettingsLayers,
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/prometheus/portal/ReportsPage.vue'),
        children: [
            {
                path: ':template(msgs|trips|idlings|trips-parkings|statistics)',
                name: consts.routerNames.reports.template,
                meta: {
                    parentRouteName: consts.routerNames.reports.template,
                    mainRouteName: consts.routerNames.reports.main,
                },
                props: {
                    default: (route) => {
                        return {
                            template: route.params?.template
                        }
                    }
                },
                components:{
                    default: () => import("@/components/reports/ReportItem_info.vue"),
                }
            },
            {
                path: ':template(msgs|trips|idlings|trips-parkings|statistics)/:timeFrom(\\d+)?/:timeTo(\\d+)?/:objectType/:objectId',
                name: consts.routerNames.reports.system,
                meta: {
                    parentRouteName: consts.routerNames.reports.system,
                    mainRouteName: consts.routerNames.reports.main,
                    pageClass: pageClass+'__id'
                },
                props: {
                    default: (route) => {
                        return {
                            template: route.params?.template,
                            timeFrom: route.params?.timeFrom,
                            timeTo: route.params?.timeTo,
                            objectType: route.params?.objectType,
                            objectId: route.params?.objectId,
                        }
                    }
                },
                components:{
                    default: () => import("@/components/reports/ReportSystem.vue"),
                }
            },
            {
                path: ':template/:timeFrom(\\d+)/:timeTo(\\d+)/:objectType/:objectId/:reportId',
                name: consts.routerNames.reports.mongo,
                meta: {
                    parentRouteName: consts.routerNames.reports.mongo,
                    mainRouteName: consts.routerNames.reports.main,
                    pageClass: pageClass+'__id'
                },
                props: {
                    default: (route) => {
                        return {
                            reportId: route.params?.reportId,
                            template: route.params?.template,
                            timeFrom: route.params?.timeFrom,
                            timeTo: route.params?.timeTo,
                            objectType: route.params?.objectType,
                            objectId: route.params?.objectId,
                        }
                    }
                },
                components:{
                    default: () => import("@/components/reports/ReportMongo.vue"),
                }
            },
            {
                path: 'job-manager',
                name: consts.routerNames.reports.jobManager.main,
                meta: {
                    parentRouteName: consts.routerNames.reports.main,
                    mainRouteName: consts.routerNames.reports.main,
                    pageClass: pageClass+'__id'
                },
                props: {
                    // default: (route) => {
                    //     return {}
                    // }
                },
                components:{
                    default: () => import("@/components/reports/JobManager/JobManagerPage.vue"),
                },
                children: [
                    {
                        path: ':reportSchedulerId/edit',
                        name: consts.routerNames.reports.jobManager.edit,
                        meta: {
                            parentRouteName: consts.routerNames.reports.jobManager.main,
                            mainRouteName: consts.routerNames.reports.main,
                            blockingRoutesTransitionFromOutside: true,
                            sectionPopupByRoute: {
                                SectionWrapByRoutePopup: {
                                    // class: 'popup-full',
                                    titlePosition: 'center',
                                    hideSteps: true,
                                }
                            },
                        },
                        props: {
                            sectionPopupByRoute: (route) => ({
                                reportSchedulerId: route.params.reportSchedulerId,
                                wrapper: 'EditWizard',
                                hideSteps: true,
                                ignoreStepForButton: true,
                            })
                        },
                        components: {
                            sectionPopupByRoute: () => import('@/components/reports/JobManager/report-scheduler/ReportSchedulerEdit'),
                        }
                    },
                ]
            }
        ]
    },
];

export default routes;